import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];
  declare checkboxTargets: HTMLInputElement[];

  selectAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = true;
    });

    this.updateSubmissionFields();
  }

  clearAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false;
    });

    this.updateSubmissionFields();
  }

  toggleChanged() {
    this.updateSubmissionFields();
  }

  updateSubmissionFields() {
    const anyChecked = this.checkboxTargets.some(
      (checkbox) => checkbox.checked
    );

    document
      .querySelectorAll("[data-sample-plan-disable-without-fields]")
      .forEach((el) => {
        (el as HTMLButtonElement).disabled = !anyChecked;
      });

    document
      .querySelectorAll("[data-sample-plan-show-without-fields]")
      .forEach((el) => {
        (el as HTMLElement).classList.toggle("invisible", anyChecked);
      });
  }
}
